module.exports = __webpack_public_path__ + "img/wf-finishing-position-20.3e4c5a53.svg";